var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningNoFill = function SvgWarningNoFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DB3B28",
    fillRule: "evenodd",
    d: "M24 24 12 0 0 24zm-13.286-3.692v-2.77h2.572v2.77zm0-4.616h2.572v-5.538h-2.572z",
    clipRule: "evenodd"
  })));
};
export default SvgWarningNoFill;